var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page--fill"},[(_vm.$env.billing)?_c('data-list',{attrs:{"title":"Consommations","client":"billing","resource":"lines","columns":_vm.columns,"filters":_vm.filters},scopedSlots:_vm._u([{key:"code",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"cell-mono"},[_vm._v(_vm._s(item.code))])]}}],null,false,4026556353)}):_c('billing-unavailable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }